import baseApi from 'shared/api/baseApi';

import type { ActivityQueryParams, ActivityResponse } from '../model/activity';

/**
 * GET /backoffice/activity/{masterProjectId}
 *
 * Query params:
 *  - domain?: 'alert' | 'task' | 'question'   (sin enviar = todos)
 *  - status?: ActivityStatus                  (sin enviar = todos)
 *  - search?: string                          (busca en clientName/subProjectName/contenido)
 *  - limit?: number                           (default backend, recomendado 20)
 *  - offset?: number
 *
 * Esperado del backend (pendiente):
 *  - Devolver `counts` con el total por dominio respetando `status` y `search`,
 *    PERO ignorando `domain` (para que los chips muestren el total disponible
 *    en cada categoría aunque estés mirando una sola).
 *    Forma: { all: number, alert: number, task: number, question: number }
 *  - Soporte de búsqueda por `search` en columnas: clientName, subProjectName,
 *    alert.messageText, task.title, question.question.
 *  - Mientras `counts` no exista en la respuesta, el front cae a "—" y
 *    `data.total` para el chip "Todas".
 */
const activityApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getActivity: build.query<ActivityResponse, ActivityQueryParams>({
      query: ({ masterProjectId, domain, status, search, limit, offset }) => ({
        url: `/backoffice/activity/${masterProjectId}`,
        method: 'GET',
        params: {
          ...(domain && domain !== 'all' ? { domain } : {}),
          ...(status && status !== 'all' ? { status } : {}),
          ...(search ? { search } : {}),
          ...(limit !== undefined ? { limit } : {}),
          ...(offset !== undefined ? { offset } : {}),
        },
      }),
      providesTags: (_result, _error, { masterProjectId }) => [{ type: 'Activity', id: masterProjectId }],
    }),
  }),
  overrideExisting: false,
});

export const { useGetActivityQuery } = activityApi;

export default activityApi;
